import React from 'react';

const CrmIcon = () => {
  return (
    <svg width="16" height="15" viewBox="0 0 16 15" fill="none">
      <path
        d="M11.2457 14.25C12.5058 14.25 13.1359 14.25 13.6172 14.0048C14.0405 13.789 14.3848 13.4448 14.6005 13.0215C14.8457 12.5402 14.8457 11.9101 14.8457 10.65V4.35C14.8457 3.08988 14.8457 2.45982 14.6005 1.97852C14.3848 1.55516 14.0405 1.21095 13.6172 0.995236C13.1359 0.750001 12.5058 0.750001 11.2457 0.750001L4.9457 0.75C3.68559 0.75 3.05553 0.75 2.57422 0.995235C2.15086 1.21095 1.80665 1.55516 1.59094 1.97852C1.3457 2.45982 1.3457 3.08988 1.3457 4.35L1.3457 10.65C1.3457 11.9101 1.3457 12.5402 1.59094 13.0215C1.80665 13.4448 2.15086 13.789 2.57422 14.0048C3.05553 14.25 3.68558 14.25 4.9457 14.25H11.2457Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.39438 8.39602C9.34147 8.23729 9.31501 8.15792 9.31639 8.093C9.31783 8.02472 9.32697 7.98893 9.35841 7.9283C9.3883 7.87065 9.46823 7.79627 9.6281 7.64752C10.0696 7.23671 10.3457 6.6506 10.3457 6C10.3457 4.75736 9.33834 3.75 8.0957 3.75C6.85306 3.75 5.8457 4.75736 5.8457 6C5.8457 6.6506 6.12184 7.23671 6.56331 7.64752C6.72317 7.79627 6.8031 7.87065 6.833 7.9283C6.86444 7.98893 6.87357 8.02472 6.87502 8.093C6.87639 8.15792 6.84994 8.23729 6.79703 8.39602L6.10895 10.4603C6.02007 10.7269 5.97563 10.8602 6.00228 10.9663C6.0256 11.0592 6.08358 11.1397 6.16433 11.1912C6.25658 11.25 6.3971 11.25 6.67816 11.25H9.51325C9.7943 11.25 9.93483 11.25 10.0271 11.1912C10.1078 11.1397 10.1658 11.0592 10.1891 10.9663C10.2158 10.8602 10.1713 10.7269 10.0825 10.4603L9.39438 8.39602Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CrmIcon;
